module.exports = __webpack_public_path__ + "static/media/ethcat.c59a30d5.png";